import TimeListDataOutput from './TimeListDataOutput';

export default TimeListDataOutput;
